import { stripAssetMarkers } from '../../_utils/assetMarkers';

// Minimal structural view of an mdast node — enough to walk the tree without adding a
// direct dependency on @types/mdast or unist-util-visit (only transitive under pnpm).
export interface MarkdownNode {
    type: string;
    value?: string;
    children?: MarkdownNode[];
}

function stripTextNodes(node: MarkdownNode): void {
    if (node.type === 'text' && typeof node.value === 'string') {
        node.value = stripAssetMarkers(node.value);
    }
    node.children?.forEach(stripTextNodes);
}

/**
 * remark plugin that removes `SB{V,I,A}-<contentId>` asset codes from assistant markdown
 * before it renders. Display-only: the raw text in thread state keeps its codes so
 * useTopResults can still parse them.
 */
export function remarkStripAssetMarkers(): (tree: MarkdownNode) => void {
    return stripTextNodes;
}
